import { Image } from 'expo-image';
import { StyleSheet, Text, View } from 'react-native';

import { fontSize } from '@/constants/theme';
import type { AppColors } from '@/constants/theme';
import { useTheme } from '@/contexts/ThemeContext';

type Props = {
  uri?: string | null;
  name?: string | null;
  size?: number;
  showCameraPrompt?: boolean;
};

export function Avatar({ uri, name, size = 56, showCameraPrompt = false }: Props) {
  const { colors } = useTheme();
  const styles = makeStyles(colors);
  const radius = size / 2;
  const initial = (name?.trim()?.[0] ?? '?').toUpperCase();

  if (uri) {
    return (
      <Image
        source={{ uri }}
        style={[styles.base, { width: size, height: size, borderRadius: radius }]}
        contentFit="cover"
        cachePolicy="disk"
      />
    );
  }

  if (showCameraPrompt) {
    return (
      <View style={[styles.base, styles.cameraWrap, { width: size, height: size, borderRadius: radius }]}>
        <Text style={[styles.addText, { fontSize: size * 0.22 }]}>Βάλε φωτό +</Text>
      </View>
    );
  }

  return (
    <View style={[styles.base, styles.fallback, { width: size, height: size, borderRadius: radius }]}>
      <Text style={[styles.initial, { fontSize: size * 0.4 }]}>{initial}</Text>
    </View>
  );
}

function makeStyles(colors: AppColors) {
  return StyleSheet.create({
    base: {
      backgroundColor: colors.surfaceAlt,
    },
    fallback: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    cameraWrap: {
      alignItems: 'center',
      justifyContent: 'center',
      borderWidth: 2,
      borderColor: colors.primary,
      borderStyle: 'dashed',
    },
    initial: {
      color: colors.text,
      fontWeight: '700',
    },
    addText: {
      color: colors.primary,
      fontWeight: '700',
      textAlign: 'center',
      paddingHorizontal: 4,
    },
  });
}
